<div class="superadmin-popup">
  <h4 class="dialog-title text-center">{{ 'Edit Shadow Constraint' | translate }}</h4>

  <hr />

  <app-progress-spinner [show]="isFormLoading"></app-progress-spinner>

  <div class="mb-4">
    <div mat-dialog-content>
      <div class="row">
        <div class="col-md-12">
          <mat-form-field>
            <mat-label>{{ 'Device Version' | translate }}</mat-label>
            <mat-select [(ngModel)]="shadowConstraint.deviceVersionId" required>
              @for (deviceVersion of deviceVersions; track trackById($index, deviceVersion)) {
                <mat-option [value]="deviceVersion.id">
                  {{deviceVersion.version}}
                </mat-option>
              }
            </mat-select>
            <mat-icon matPrefix class="mr-3">
              <i class="fas fa-laptop-code"></i>
            </mat-icon>
            <mat-error>{{ 'Device Version is required' | translate }}</mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-12">
          <mat-form-field>
            <mat-label>{{ 'Field' | translate }}</mat-label>
            <input matInput [(ngModel)]="shadowConstraint.field" required />
            <mat-icon matPrefix class="mr-3">
              <i class="fas fa-file-invoice"></i>
            </mat-icon>
            <mat-error>{{ 'Field is required' | translate }}</mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-12">
          <mat-form-field>
            <mat-label>{{ 'Constraint Type' | translate }}</mat-label>
            <mat-select [(ngModel)]="shadowConstraint.constraintTypeId" required>
              @for (constraintType of constraintTypes; track trackById($index, constraintType)) {
                <mat-option [value]="constraintType.id">
                  {{constraintType.value}}
                </mat-option>
              }
            </mat-select>
            <mat-icon matPrefix class="mr-3">
              <i class="fas fa-ruler"></i>
            </mat-icon>
            <mat-error>{{ 'Constraint Type is required' | translate }}</mat-error>
          </mat-form-field>
        </div>

        @if (shadowConstraint.constraintTypeId !== ConstraintTypeEnum.Readonly && shadowConstraint.constraintTypeId !== ConstraintTypeEnum.SuperAdminOnly && shadowConstraint.constraintTypeId !== ConstraintTypeEnum.Rename) {
          <div class="col-md-12">
            <mat-form-field>
              <mat-label>{{ 'Operator' | translate }}</mat-label>
              <mat-select [(ngModel)]="shadowConstraint.operatorTypeId" required>
                @for (operatorType of operatorTypes; track trackById($index, operatorType)) {
                  <mat-option [value]="operatorType.id">
                    {{operatorType.value}}
                  </mat-option>
                }
              </mat-select>
              <mat-icon matPrefix class="mr-3">
                <i class="fas fa-greater-than-equal"></i>
              </mat-icon>
              <mat-error>{{ 'Operator is required' | translate }}</mat-error>
            </mat-form-field>
          </div>
        }

        @if (shadowConstraint.constraintTypeId !== ConstraintTypeEnum.Readonly && shadowConstraint.constraintTypeId !== ConstraintTypeEnum.SuperAdminOnly) {
          <div class="col-md-12">
            <mat-form-field>
              <mat-label>{{ shadowConstraint.constraintTypeId === ConstraintTypeEnum.Relative ? ('Other Field' | translate) : ('Value' | translate) }}</mat-label>
              <input matInput [(ngModel)]="shadowConstraint.operatorValue" required />
              <mat-icon matPrefix class="mr-3">
                <i class="fas fa-file-alt"></i>
              </mat-icon>
              <mat-error>
                {{ shadowConstraint.constraintTypeId === ConstraintTypeEnum.Relative ? ('Other Field is required' | translate) : ('Value is required' | translate) }}
              </mat-error>
            </mat-form-field>
          </div>
        }

        @if (shadowConstraint.constraintTypeId === ConstraintTypeEnum.Bounded) {
          <div class="col-md-12">
            <mat-form-field>
              <mat-label>{{ 'Operator 2' | translate }}</mat-label>
              <mat-select [(ngModel)]="shadowConstraint.operatorTypeId2" required>
                @for (operatorType of operatorTypes; track trackById($index, operatorType)) {
                  <mat-option [value]="operatorType.id">
                    {{operatorType.value}}
                  </mat-option>
                }
              </mat-select>
              <mat-icon matPrefix class="mr-3">
                <i class="fas fa-greater-than-equal"></i>
              </mat-icon>
              <mat-error>{{ 'Operator 2 is required' | translate }}</mat-error>
            </mat-form-field>
          </div>
        }

        @if (shadowConstraint.constraintTypeId === ConstraintTypeEnum.Bounded) {
          <div class="col-md-12">
            <mat-form-field>
              <mat-label>{{ 'Value 2' | translate }}</mat-label>
              <input matInput [(ngModel)]="shadowConstraint.operatorValue2" required />
              <mat-icon matPrefix class="mr-3">
                <i class="fas fa-file-alt"></i>
              </mat-icon>
              <mat-error>{{ 'Value 2 is required' | translate }}</mat-error>
            </mat-form-field>
          </div>
        }
      </div>
    </div>

    <div mat-dialog-actions align="end">
      <button mat-button class="btn button-primary" (click)="save()" [class.button-spinner]="isLoading"
        [disabled]="isDisabled() || isLoading">
        {{ 'Save' | translate }}
      </button>

      <button mat-button class="btn button-accent" mat-dialog-close>{{ 'Cancel' | translate }}</button>
    </div>
  </div>
</div>